import { createFileRoute } from '@tanstack/react-router'

import { InsuranceCertificateGeneratorRealEstateSalesAgentsPageSkeleton } from '#/modules/contract/front-office/insurance-certificate-generator-real-estate-sales-agents-page/insurance-certificate-generator-real-estate-sales-agents-page-skeleton.tsx'
import { InsuranceCertificateGeneratorRealEstateSalesAgentsPage } from '#/modules/contract/front-office/insurance-certificate-generator-real-estate-sales-agents-page/insurance-certificate-generator-real-estate-sales-agents-page.tsx'
import { FRONT_OFFICE_V2_QUERY_OPTIONS } from '#/shared/front-office-v2-query-options.ts'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute(
  '/(customer)/_shell/insurance-certificate-generator-real-estate-sales-agents-v2/$subscriptionId/',
)({
  beforeLoad: ({ context }) => requirePermissions(context, ['contract.read']),
  // This screen reads no contract data; the only thing it needs up front is today's date, which
  // bounds "date de délivrance" and marks today in the calendar.
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(
      context.trpc.timeManipulation.getCurrentCalendarDate.queryOptions(undefined, FRONT_OFFICE_V2_QUERY_OPTIONS),
    ),
  pendingComponent: InsuranceCertificateGeneratorRealEstateSalesAgentsPageSkeleton,
  pendingMs: 150,
  component: InsuranceCertificateGeneratorRealEstateSalesAgentsRoute,
})

function InsuranceCertificateGeneratorRealEstateSalesAgentsRoute() {
  const { subscriptionId } = Route.useParams()
  return <InsuranceCertificateGeneratorRealEstateSalesAgentsPage subscriptionId={subscriptionId} />
}
